import React from 'react';
import { getPolyglot } from '../../../../../../i18n';
import { GroupActionsProps } from './GroupActions';
import { useAppSelector } from '../../../../../../redux/store.model';
import {
  ButtonIcon,
  MenuItemPrimary,
} from '../../../../../../theme/components';
import { ListItemIcon } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getFeatureToggle } from '../../../../../../featureToggle';
import useModuleSelected from '../../../../navigations/useModuleSelected';
import { ReportIcon } from '../../../../../../theme/icons';
import ReportAPI from '../../../../../../redux/reports/api/ReportAPI';
import { getMyWorkspaceIdSelector } from '../../../../../../redux/stoerkID/selectors/StoerkId.selectors';
import { skipToken } from '@reduxjs/toolkit/query';

const iconId = 'report';
const icon = <ReportIcon />;

export function GroupReportAction(props: GroupActionsProps) {
  const { group, variant } = props;

  const polyglot = getPolyglot();
  const navigate = useNavigate();
  const tooltipContent = polyglot.t('reports.reports');
  const onClickAction = (e: React.MouseEvent) => {
    const url = `/devicemanager/group/${params.groupId ?? ''}/reports`;
    navigate(url);
  };
  const workspaceId = useAppSelector(getMyWorkspaceIdSelector);
  const { data: reportTypes, ...rest } =
    ReportAPI.endpoints.getReportTypes.useQuery(workspaceId ?? skipToken);
  const featureToggle = useAppSelector(getFeatureToggle);
  const params = { groupId: group?.id ?? undefined };

  const moduleSelected = useModuleSelected();
  const selected = moduleSelected === 'reports';

  if (!group) return null;
  if (!featureToggle.reports || !reportTypes?.length) return null;

  return (
    <React.Fragment>
      {variant === 'menuItem' ? (
        <MenuItemPrimary
          onClick={onClickAction}
          className={`icon-${iconId} group-${group.id}`}
          selected={selected}
        >
          <ListItemIcon sx={{ color: 'inherit' }}>{icon}</ListItemIcon>
          {tooltipContent}
        </MenuItemPrimary>
      ) : (
        <ButtonIcon
          className={`icon-${iconId} group-${group.id}`}
          tooltip={tooltipContent}
          onClick={onClickAction}
          selected={selected}
          sx={{ width: '45px', height: '45px' }}
        >
          {icon}
        </ButtonIcon>
      )}
    </React.Fragment>
  );
}
export default GroupReportAction;
